<style scoped lang="stylus" rel="stylesheet/stylus">
.container
  background #f2f2f2
  min-height 100%
  &>div
    border-bottom 1px solid #ccc
    .title
      font-size 15px
      color #333
      text-align center
      font-weight bold
    .tip
      font-size 14px
      color #888
</style>

<template>
	<div class="container">
		<nav-bar />
		<pdf-viewer
			:isPdfViewerShow="isPdfViewerShow"
			:serverUrl="serverUrl"
			:pdfUrl="pdfUrl"
			pdfName=""
			@close="closePdf"
		></pdf-viewer>
		<div>
			<div class="title">vue-pdf</div>
			<div>
				<van-button @click="openPdf('../../assets/pdf.pdf')">pdf.pdf</van-button>
				<van-button @click="openPdf('../../assets/password.pdf')">打开password.pdf</van-button>
				<van-button
					@click="openPdf('http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf')"
					>打开网络pdf</van-button
				>
			</div>
		</div>
		<input type="text" placeholder="请输入" />
		<van-button @click="$router.push('/slot')">跳转插槽页</van-button>
	</div>
</template>

<script>
import loading from '../../components/feedback/loading'
import pdfViewer from '../../components/business/pdf-viewer'
import navBar from '../../components/navigation/nav-bar'
export default {
	name: 'pdf',
	components: {
		// loading,
		pdfViewer,
		navBar
	},
	props: {},
	data() {
		return {
			isPdfViewerShow: false,
			// serverUrl: '/static/pdfjs/web/viewer.html?file=', // 使用本地地址在安卓端无法找到
			serverUrl: 'http://116.62.150.185/pdfjs/web/viewer.html?file=', // 改成使用网络地址
			pdfUrl: ''
		}
	},
	filters: {},
	computed: {},
	methods: {
		// 打开pdf
		async openPdf(pdfUrl) {
			this.isPdfViewerShow = true
			this.pdfUrl = pdfUrl
		},
		// 关闭pdf
		closePdf() {
			this.isPdfViewerShow = false
			this.pdfUrl = ''
		}
	}
}
</script>
